import { render, staticRenderFns } from "./BrandProduct.vue?vue&type=template&id=10416c3f&lang=pug"
import script from "./BrandProduct.vue?vue&type=script&lang=js"
export * from "./BrandProduct.vue?vue&type=script&lang=js"
import style0 from "./BrandProduct.vue?vue&type=style&index=0&id=10416c3f&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports